import BaseVueComponent from "common/BaseVueComponent"
import { Component, Prop } from "vue-property-decorator"

import { getSavingIndicatorColor, getSavingIndicatorIcon, SavingIndicatorStatus } from "./savingIndicator.utils"

/**
 * Saving Indicator Base Component
 *
 * @description The base Saving Indicator component for both Web and Mobile.
 * @augments BaseVueComponent
 * @global
 */
@Component
export default class SavingIndicatorBase extends BaseVueComponent {
    @Prop({ type: String, default: "saved" }) public status!: SavingIndicatorStatus

    public get iconToShow(): string {
        return getSavingIndicatorIcon(this.status)
    }

    public get iconColor(): string {
        return getSavingIndicatorColor(this.status)
    }

    public get inProgress(): boolean {
        return this.status === "saving"
    }

    public get message(): string {
        switch (this.status) {
            case "error":
                return "Will be saved when all errors have been fixed."
            case "syncError":
                return "Couldn't sync to the server. Will retry automatically."
            case "saved":
                return "Saved."
            case "pending":
                return "Saved on this device. Will sync when back online."
            case "validated":
                return "Validated."
            case "saving":
                return "Saving in progress..."
            case "locked":
                return this.project?.data.active ? "Locked from editing." : "Project is inactive"
        }
    }
}
